import { render, staticRenderFns } from "./disposalStatistics.vue?vue&type=template&id=dfa80cea&scoped=true"
import script from "./disposalStatistics.vue?vue&type=script&lang=js"
export * from "./disposalStatistics.vue?vue&type=script&lang=js"
import style0 from "./disposalStatistics.vue?vue&type=style&index=0&id=dfa80cea&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfa80cea",
  null
  
)

export default component.exports